<template>
  <div class="question">
    <div class="question__message">
      <RichTextRenderer tag="div" class="question__message-answer" :html="introduction.content" />

      <div class="content">
        <div class="content__item content__item--action">
          <UIButton :id="'game-button-message'" class="content__item-action--next" @click="$emit('closeIntroduction')">
            {{ applyReplacementTags(introduction.buttonLabel || customLabels.buttons.answer || 'Næste spørgsmål') }}
          </UIButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import type { CustomLabelState, GameQuizQuestionIntroductionState } from '@/src/components/games/quiz/Model';
import { applyReplacementTags, preloadImagePromise } from '@/src/utilities/Utilities';
import UIButton from '@/src/components/ui/UIButton.vue';
import { useCampaignStore } from '@/src/store/campaign';
import RichTextRenderer from '@/src/components/RichTextRenderer.vue';

export default defineComponent({
  name: 'QuizQuestionIntroduction',
  components: { RichTextRenderer, UIButton },
  props: {
    introduction: {
      type: Object as PropType<GameQuizQuestionIntroductionState>,
      required: true
    },
    customLabels: {
      type: Object as PropType<CustomLabelState>,
      required: true
    }
  },
  emits: ['closeIntroduction'],
  setup(props) {
    const campaignStore = useCampaignStore();

    let readyPromiseResolve: (() => void) | undefined;
    const readyPromise = new Promise<void>((resolve) => {
      readyPromiseResolve = resolve;
    });

    (async () => {
      if (props.introduction.backgroundImage?.onIntroduction && props.introduction.backgroundImage.src) {
        await preloadImagePromise(props.introduction.backgroundImage.src).then(() => {
          if (props.introduction.backgroundImage?.enabled) {
            campaignStore.gameSectionImageOverlay = props.introduction.backgroundImage;
          } else {
            campaignStore.gameSectionImageOverlay = undefined;
          }
        });
      }

      if (readyPromiseResolve) {
        readyPromiseResolve();
      }
    })();

    return {
      applyReplacementTags,
      onBeforeEnter: async () => {
        await readyPromise;
      }
    };
  }
});
</script>
